import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import StaticContentStore from '../../stores/StaticContentStore';

const StaticPage = ({ content }) => {
  // If the document's content hasn't been loaded yet, display a spinner.
  if (!content || !content.html || !content.meta) {
    return (
      <section className="docs-content">
        <div className="auth0-spinner">
          <div className="spinner" />
        </div>
      </section>
    );
  }

  let classes = ['content'];
  if (content.meta) classes = classes.concat(content.meta.classes);

  return (
    <section
      className={classes.join(' ')}
      data-swiftype-name="body"
      data-swiftype-type="text"
      data-swiftype-index="true"
      dangerouslySetInnerHTML={{ __html: content.html }}
    />
  );
};

StaticPage.propTypes = {
  content: PropTypes.object
};

export default connectToStores(StaticPage, [StaticContentStore], (context, props) => {
  const staticContentStore = context.getStore(StaticContentStore);

  return {
    url: props.currentRoute.url,
    content: staticContentStore.getContent()
  };
});
